import React from 'react';
import toast, { Toaster } from 'react-hot-toast';

import {confirmAlert} from "react-confirm-alert";
import Role from "../../inc/Role";
import {NavLink, useNavigate, useParams} from "react-router-dom";
import * as Icon from "react-bootstrap-icons";
import {Config} from '../../Config'
import Select from 'react-select'
import * as Utils from "../../inc/Utils";
import moment from "moment-timezone";

export default function AdsNamingCreativeAlwaysCreate() {
    const roles = new Role();
    let userId = roles.loginUserId;

    //region duplicate
    let adsNamingId = null;
    let {encode} = useParams();
    if(encode) {
        let decode = Utils.decodeItem(encode);
        adsNamingId = decode.id;
    }
    //endregion

    let btnTextDefault = 'บันทึกข้อมูล';
    let btnTextLoading = 'กำลังบันทึก..';
    let [isLoading, setLoading] = React.useState(false);
    let [pillar, setPillar] = React.useState('');
    let [pillarId, setPillarId] = React.useState(null);
    //region duplicate
    let [name, setName] = React.useState(null);
    let [preview, setPreview] = React.useState(null);
    //endregion
    const navigate = useNavigate();

    let refName = React.useRef();
    React.useEffect(() => {
        (async function() {
            try {
                const resPillar = await getPillar();
                setPillar(resPillar);
                //region duplicate
                if(adsNamingId) {
                    const resView = await getView(adsNamingId);
                    setName(resView.name);
                    setPillarId(resView.pillar);
                    setPreview(resView.params);
                }
                //endregion
            } catch (e) {
                toast.error(e.message);
            }
        })();
    }, []);

    //region duplicate
    async function getView(id) {
        const response = await fetch(Config.url.API_URL +'/api/adsNamingCreativeAlways/view', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            },
            body: JSON.stringify({
                id: id
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }
    //endregion

    async function getPillar() {
        const response = await fetch(Config.url.API_URL +'/api/adsNamingContentPillar/listingName', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            },
            body: JSON.stringify({
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getPillarView(id) {
        const response = await fetch(Config.url.API_URL +'/api/adsNamingContentPillar/view', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            },
            body: JSON.stringify({
                id: id
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    const onCreate = () => {
        let name = refName.current.value;
        if(!pillarId) {
            toast.error("กรุณาระบุ Content Pillar");
        }
        else if(!name) {
            toast.error("กรุณาระบุ Creative Name");
            refName.current.focus();
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการบันทึกข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: async () => {
                            setLoading(true);

                            let pillarView = await getPillarView(pillarId.id);
                            let params = pillarView.name + '_' + name + '_[ST]';

                            const body = {
                                adsNamingContentPillarId: pillarId.id,
                                adsNamingContentPillarText: pillarView.name,
                                name: name,
                                params: params,
                                createdBy: userId,
                                createdAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss')
                            };
                            fetch(Config.url.API_URL +'/api/adsNamingCreativeAlways/create', {
                                method: 'POST',
                                body: JSON.stringify(body),
                                headers: {
                                    'Content-Type':'application/json',
                                    'x-access-token': roles.accessToken
                                }
                            }).then(response => {
                                setLoading(false);
                                if(response.ok) {
                                    return response.json();
                                }
                                else {
                                    return response.json().then(err => Promise.reject(err));
                                }
                            }).then(result => {
                                if(result) {
                                    toast.success("บันทึกข้อมูลเรียบร้อย");
                                    setTimeout(function () {
                                        navigate('/adsNamingCreativeAlways', {replace: true});
                                    }, 1500);
                                }
                            }).catch(err => {
                                toast.error(err.message);
                            })
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    const onChangePillarId = async (obj) => {
        setPillarId(obj);
        let params = '';
        if(obj) {
            let pillarView = await getPillarView(obj.id);
            params = pillarView.name + '_' + refName.current.value + '_[ST]';
        }
        setPreview(params);
    };

    const onPreview = async () => {
        let params = '';
        refName.current.value = Utils.utmSlug(refName.current.value);
        if(pillarId && pillarId.id && refName.current.value) {
            let pillarView = await getPillarView(pillarId.id);
            params = pillarView.name + '_' + refName.current.value + '_[ST]';
        }
        setPreview(params);
    };

    return (
        <main>
            <div className="row table-toolbar mb-2">
                <div className="col-6 align-self-center">
                    <div className="h6 d-inline"><span className="text-success">&#8226;</span> Generate Creative Naming</div>
                    <span className="ms-1">/</span> <span className="text-muted">Project</span>
                    <span className="ms-1">/</span> <span className="text-muted">Create</span>
                </div>
                <div className="col-6 text-end align-self-center toolbars">
                </div>
            </div>
            <div className="rounded bg-white p-4 shadow">
                <div className="row">
                    <div className="col-12 col-md-6">
                        <form className="row g-3">
                            <div className="col-12">
                                <label htmlFor="name" className="form-label">Content Pillar <span className="text-danger">*</span></label>
                                <Select
                                    isClearable={true}
                                    classNamePrefix="form-select-search"
                                    options={pillar}
                                    onChange={(event) => onChangePillarId(event)}
                                    value={pillarId}
                                    getOptionValue={(option) => `${option.id}`}
                                    getOptionLabel={(option) => `${option.name}`}
                                />
                            </div>
                            <div className="col-12">
                                <label htmlFor="name" className="form-label">Creative Name</label>
                                <input type="text" className="form-control" id="name" ref={refName} maxLength={100} onKeyUp={onPreview} defaultValue={name} />
                            </div>
                            <div className="col-12 p-3 mt-4">
                                <div className="row border rounded bg-green-light py-2">
                                    <div className="col-12">
                                        <label htmlFor="preview" className="form-label">Preview</label>
                                        <div className="noselect-url w100 rounded">{preview}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <button type="button" className="btn btn-primary" onClick={onCreate}><span
                                    className={isLoading ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span> {isLoading ? btnTextLoading : btnTextDefault}</button>
                                <NavLink className="btn btn-sm btn-light ms-2" to='/adsNamingCreativeAlways'><span><Icon.ArrowLeft/> กลับไป</span></NavLink>
                                <Toaster position="bottom-right" />
                            </div>
                        </form>
                    </div>
                    <div className="col-12 col-md-6"></div>
                </div>
            </div>
        </main>
    );
} 